import CommonTextNodes from '@data/i18n/common.json'

export default function AccountInfoBar() {
	return (
		<div className="bg-bbx-spark text-white py-4 font-medium text-center max-md:text-xs">
			<div className="container">{CommonTextNodes.accountLayout.updatingWebsite}</div>
		</div>
	)
}
